import React from 'react';
import logo from "../assests/images/logo.jpg";
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const socialButtonStyle = {
    backgroundColor: '#FFA916',
    border: 'none',
    borderRadius: '50%',
    width: '35px',
    height: '35px',
    color: '#024A59',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    ':hover': {
      transform: 'scale(1.1)',
      backgroundColor: '#024A59',
      color: '#FFA916'
    }
  };

  const linkStyle = {
    color: "rgba(255,255,255,0.9)",
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    padding: '4px 0',
    display: 'block',
    fontSize: '0.95rem',
    ':hover': {
      color: '#FFA916',
      transform: 'translateX(3px)',
      textDecoration: 'underline'
    }
  };

  return (
    <div style={{ 
      backgroundColor: "#000000",
      backgroundImage: 'linear-gradient(rgba(0,0,0,0.9), rgba(0,0,0,0.95)), url(https://www.transparenttextures.com/patterns/diagonal-striped-brick.png)',
      padding: '40px 0 30px',
      position: 'relative',
      borderTop: '3px solid #FFA916',
      boxShadow: '0 -10px 30px rgba(0,0,0,0.3)'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '30px',
          paddingBottom: '40px'
        }}>
          {/* Address Column */}
          <div>
            <h5 style={{ color: '#FFA916', fontSize: '1.2rem', marginBottom: '20px', fontWeight: '600' }}>Get in Touch</h5>
            <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <MapPin color="#FFA916" size={18} />
              <p style={{ color: 'rgba(255,255,255,0.9)', margin: 0, fontSize: '0.95rem' }}>Ngong, Uptown Mall</p>
            </div>
            <div style={{ marginBottom: '12px',  marginLeft: '30px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <p style={{ color: 'rgba(255,255,255,0.9)', margin: 0, fontSize: '0.95rem' }}>Nairobi, Kenya</p>
            </div>
            <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Phone color="#FFA916" size={18} />
              <div>
                <a href="https://wa.me/254796265933" style={linkStyle}>+254 796 265933</a>
                <a href="https://wa.me/254728813009" style={linkStyle}>+254728 813009</a>
              </div>
            </div>
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Mail color="#FFA916" size={18} />
              <a href="mailto:info@statify.co.ke" style={linkStyle}>info@statify.co.ke</a>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              {[
                { Icon: Facebook, url: 'https://facebook.com' },
                { Icon: Twitter, url: 'https://twitter.com' },
                { Icon: Linkedin, url: 'https://linkedin.com' },
                { Icon: Instagram, url: 'https://instagram.com' }
              ].map(({ Icon, url }, index) => (
                <button
                  key={index}
                  onClick={() => window.open(url, '_blank')}
                  style={socialButtonStyle}
                >
                  <Icon size={18} color="currentColor" />
                </button>
              ))}
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h5 style={{ color: '#FFA916', fontSize: '1.2rem', marginBottom: '20px', fontWeight: '600' }}>Our Products</h5>
            {[
              'Microsoft Dynamics 365 Office',
              'Dynamics 365 Business Central/NAV',
              'Microsoft Dynamics CRM',
              'Microsoft Azure',
              'Power BI',
              'Erpnext'
            ].map((service, index) => (
              <a key={index} href="/products" style={linkStyle}>{service}</a>
            ))}
          </div>

          {/* Quick Links Column */}
          <div>
            <h5 style={{ color: '#FFA916', fontSize: '1.2rem', marginBottom: '20px', fontWeight: '600' }}>Quick Links</h5>
            {[
              { text: 'Home', url: '/' },
              { text: 'About Us', url: '/about' },
              { text: 'Contact Us', url: '/contact' },
              { text: 'Products', url: '/products' },
              { text: 'Privacy Policy', url: '/privacy' }
            ].map((link, index) => (
              <a key={index} href={link.url} style={linkStyle}>{link.text}</a>
            ))}
          </div>

          {/* Company Info Column */}
          <div>
            <img 
              src={logo}
              href='/' 
              alt="Statify Logo" 
              style={{ 
                width: '140px', 
                height: 'auto', 
                marginBottom: '20px',
                transition: 'transform 0.3s ease',
                cursor: 'pointer',
                filter: 'brightness(110%) drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            />
            <p style={{ 
              color: '#FFA916', 
              fontSize: '0.95rem',
              marginBottom: '10px',
              letterSpacing: '0.5px',
              fontStyle: 'oblique'
            }}>
              Statify Solutions Limited
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div style={{
          borderTop: '1px solid rgba(255,169,22,0.3)',
          // padding: '15px 0 0',
          textAlign: 'center'
        }}>
          <p style={{ 
            color: 'rgba(255,255,255,0.7)', 
            margin: 0,
            fontSize: '0.85rem',
            lineHeight: '1.5',
            letterSpacing: '0.5px'
          }}>
            © {new Date().getFullYear()} <a href='/statify.co.ke' style={{color:'#FFA916'}}>Statify Solutions Limited.</a> All rights reserved <br/>
            {/* <a href="/" style={{ color: '#FFA916', textDecoration: 'none' }}>
              Terms of Service
            </a> */}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
